import { useState } from 'react'
import { Link } from 'react-router-dom'
import { debounce } from '../../services/util.service'
import { ArticleTag } from '../HomePage/ArticleTag'
import {
  articelsHomePageImages,
  images,
  postListImages,
} from '../../services/images.service'
import { motion } from 'framer-motion'
import { SearchIconInput } from '../ui/icons/user'
import { Button } from '../ui/elements'

const tagOptions = [
  'חוות דעת',
  'חדשות',
  'סיקור',
  'הכרזה',
  'השוואה',
  'ספויילר',
  'המלצות אנימה',
  'המלצות מנגה',
]

export function SearchBar({
  onSearchInput,
  onSearch,
  filterBy,
  instantResults,
}) {
  const [searchInputValue, setSearchInputValue] = useState(filterBy.title || '')

  const handleSearchInput = debounce((value) => {
    onSearchInput(value)
  }, 300)

  const handleSearchChange = (e) => {
    const value = e.target.value
    setSearchInputValue(value)
    handleSearchInput(value)
  }

  const handleSearch = (e) => {
    e.preventDefault()
    onSearch({ ...filterBy, title: searchInputValue })
  }

  const handleTagClick = (tag) => {
    const updatedTags = filterBy.tags.includes(tag)
      ? filterBy.tags.filter((t) => t !== tag)
      : [...filterBy.tags, tag]
    onSearch({ ...filterBy, tags: updatedTags }) // עדכון הפילטר
  }

  const handleClearSearch = () => {
    setSearchInputValue('') // מנקה את הערך של ה-Input
    onSearch({ title: '', tags: [] }) // איפוס הפילטר
    onSearchInput('') // מנקה גם תוצאות מיידיות
  }

  return (
    <div className="relative">
      <img
        src={postListImages.headerImg}
        alt="Banner image"
        className="absolute inset-0 w-full h-full object-cover z-10"
      />
      <div className="flex flex-col items-center h-[460px] justify-center gap-8 max-w-lg mx-auto relative z-10">
        <h1 className="text-5xl text-text">כל המאמרים</h1>

        <form
          onSubmit={handleSearch}
          className="w-full flex items-center bg-[#424242] p-2 relative"
        >
          <div className="flex items-center ps-3">
            <SearchIconInput />
          </div>
          <input
            type="text"
            id="searchInput"
            name="searchInput"
            value={searchInputValue} // הערך מנוהל על ידי state
            onChange={handleSearchChange} // מאזין לשינויים בערך
            className="flex-1 ps-3 text-lg bg-transparent focus:outline-none"
            placeholder="חפש מאמר באניזון"
          />
          <Button
            text="חיפוש"
            width={100}
            height={50}
            fontSize="text-base"
            textColor="text-white"
            bgColor="fill-primary"
            onClick={handleSearch}
            title="חפש כתבה באניזון"
            ariaLabel="מעבר לעמוד חיפוש הכתבות באניזון"
          />

          {searchInputValue && (
            <Button
              text="נקה חיפוש"
              width={100}
              height={50}
              fontSize="text-base"
              textColor="text-white"
              bgColor="fill-primary"
              onClick={handleClearSearch}
              title="נקה את החיפוש"
              ariaLabel="נקה את החיפוש והצג את כל הכתבות"
            />
          )}
        </form>

        {/* תוצאות מיידיות */}
        {instantResults.length > 0 && (
          <div className="absolute top-[50%] mt-2 left-0 w-full bg-secondary shadow-lg z-10">
            {instantResults.map((post) => (
              <div
                key={post._id}
                className="flex items-center gap-4 p-2 border-b border-primary"
              >
                <img
                  src={post.imageUrl || articelsHomePageImages.placeholder}
                  alt={post.title}
                  className="w-12 h-12 object-cover rounded"
                />
                <div>
                  <Link to={`/post/${post._id}`} className="text-softText">
                    {post.title}
                  </Link>
                  <p className="text-sm text-gray-500">
                    {post.author.nickname}
                  </p>
                </div>
              </div>
            ))}
          </div>
        )}

        <div className="flex flex-wrap gap-3 justify-center mt-4">
          {tagOptions.map((tag) => (
            <motion.div
              key={tag}
              onClick={() => handleTagClick(tag)}
              className="cursor-pointer relative"
              initial={{ scale: 1 }}
              animate={{ scale: filterBy.tags.includes(tag) ? 1.1 : 1 }}
              transition={{ duration: 0.3, ease: 'easeInOut' }}
            >
              <ArticleTag tags={[tag]} />
              {/* אם התג נבחר – מציגים קו תחתון עם אפקט fadeInRight */}
              {filterBy.tags.includes(tag) && (
                <motion.div
                  className="absolute bottom-[-4px] left-0"
                  style={{
                    borderBottomWidth: '2px', // עובי הגבול
                    borderBottomStyle: 'solid', // חובה להגדיר סגנון גבול
                    borderImageSource: `url(${images.redBorder})`, // מקור תמונת הגבול
                    borderImageSlice: '20', // קובע חיתוך לתמונה
                    borderImageRepeat: 'stretch', // למתוח את התמונה כך שתמלא את הגבול
                  }}
                  initial={{ width: 0, opacity: 0, x: 250 }}
                  animate={{ width: '100%', opacity: 1, x: 0 }}
                  transition={{ duration: 0.3, ease: 'easeInOut' }}
                />
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  )
}
